import { IEcommerceAnswerSchema, IEcommerceQuestionSchema } from '../types'

interface IUseChildrenProductsProps {
  answer: IEcommerceAnswerSchema
  schema: IEcommerceQuestionSchema
  excludeCurrentProduct?: boolean
}

// The family (parent first, then its children) that `answer` belongs to — symmetric: asking from the parent
// or from any child yields the same list. The parent's nested `children` is the source of truth (it arrives
// in display order); the flat `parent_product === market_place_id` match is kept only as a fallback for a
// schema that carries no nesting. Derived per render on purpose: the hidden mark it filters by is rewritten
// in place by markHiddenProducts, so a memo would need proxy deps mirroring the marker's.
export const useChildrenProducts = ({ answer, schema, excludeCurrentProduct = false }: IUseChildrenProductsProps) => {
  const byMarketPlaceId = new Map(schema.answers.map(product => [product.market_place_id, product]))
  const parent = answer.parent_product ? byMarketPlaceId.get(answer.parent_product) : answer
  if (!parent) return []

  const children = (
    parent.children ??
    schema.answers.filter(product => product.parent_product && product.parent_product === parent.market_place_id)
  ).filter(child => !child.hidden) // a fakeHidden child stays: the selector greys its value like a hidden card
  const family = [parent, ...children]

  return excludeCurrentProduct ? family.filter(product => product.id !== answer.id) : family
}
